const LOAD_SELECTED     = 'elements_groups/enabled_columns/LOAD_SELECTED'
const DROP_TO_SELECTED  = 'elements_groups/enabled_columns/DROP_TO_SELECTED'
const DROP_TO_AVAILABLE = 'elements_groups/enabled_columns/DROP_TO_AVAILABLE'

export const types = { LOAD_SELECTED, DROP_TO_SELECTED, DROP_TO_AVAILABLE }

export const loadSelected    = names => ({ type: LOAD_SELECTED, names })
export const dropToSelected  = (name, position) => ({ type: DROP_TO_SELECTED, name, position })
export const dropToAvailable = name => ({ type: DROP_TO_AVAILABLE, name })
